import React, { Component, ReactNode } from "react";
import ClientError from "../ClientError/ClientError";
import Error500 from "../Error500/Error500";
import Error503 from "../Error503/Error503";
interface ErrorBoundaryProps {
  status?: number;
  children: ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
}
class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    // Define a state variable to track whether there is an error or not
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(): ErrorBoundaryState {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true
    };
  }
  componentDidCatch(): void {
    // You can use your own error logging service here
  }
  render(): ReactNode {
    // Check if the error is thrown
    if (this.state.hasError) {
      return <ClientError onTryAgain={() => this.setState({
        hasError: false
      })} data-sentry-element="ClientError" data-sentry-component="ErrorBoundary" data-sentry-source-file="ErrorBoundary.tsx" />;
    } else if (this.props?.status === 503) {
      // Render Error503 for specific status code 503
      return <Error503 data-sentry-element="Error503" data-sentry-component="ErrorBoundary" data-sentry-source-file="ErrorBoundary.tsx" />;
    } else if (this.props?.status === 500) {
      // Render Error500 for specific status code 500
      return <Error500 data-sentry-element="Error500" data-sentry-component="ErrorBoundary" data-sentry-source-file="ErrorBoundary.tsx" />;
    } else {
      // Return children variants in case of no error
      return <div data-sentry-component="ErrorBoundary" data-sentry-source-file="ErrorBoundary.tsx">{this.props.children}</div>;
    }
  }
}
export default ErrorBoundary;